import React from 'react';

export const Pagination = ({ pagination, onPageChange }) => {
  if (pagination.totalPages <= 1) {
    return null;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '16px', padding: '16px' }}>
      {pagination.page > 1 && (
        <button
          className="btn btn-secondary btn-compact"
          onClick={() => onPageChange(pagination.page - 1)}
        >
          Previous
        </button>
      )}
      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        Page {pagination.page} of {pagination.totalPages}
      </span>
      {pagination.page < pagination.totalPages && (
        <button
          className="btn btn-secondary btn-compact"
          onClick={() => onPageChange(pagination.page + 1)}
        >
          Next
        </button>
      )}
    </div>
  );
};
